export default __webpack_public_path__ + "static/media/Freebooter's Helm of Crouching Calm.e44603a2.jpg";